export const CASE_MANAGER_TYPE = 'case-manager';

export const isCaseManagerUser = (user = {}) =>
	user?.type === CASE_MANAGER_TYPE;

const normalizeRoot = (root) => root || 'lifebooks';

export const getRouteRoot = (root, pathname = '') => {
	const normalizedRoot = normalizeRoot(root);
	const isConnectRoute =
		pathname === '/connect' || pathname.startsWith('/connect/');

	if (
		!isConnectRoute ||
		normalizedRoot === 'connect' ||
		normalizedRoot.startsWith('connect/')
	) {
		return normalizedRoot;
	}

	return `connect/${normalizedRoot}`;
};

export const buildFeedRoute = (root, feedType, childId) =>
	`/${normalizeRoot(root)}/${feedType}/${childId}`;

export const buildPostRoute = (root, childId, postId) =>
	`/${normalizeRoot(root)}/post/${childId}${postId ? `/${postId}` : ''}`;

export const buildProfileRoute = (root, childId) =>
	`/${normalizeRoot(root)}/child/${childId}`;

const actorIdentityMetadataKeys = [
	'createdBy',
	'createdName',
	'lastUpdatedBy',
	'lastUpdatedName',
];

export const withoutCaseManagerActorIdentity = (metadata = {}) =>
	Object.keys(metadata || {}).reduce((result, key) => {
		if (!actorIdentityMetadataKeys.includes(key)) {
			result[key] = metadata[key];
		}
		return result;
	}, {});
